export const getRowHeight = ({ data }) => [
  'DATA_BORDER_DOUBLEBOTTOMLINE',
  'DATA_BORDER_BOTTOMLINE',
].includes(data.type)
  ? 22
  : 18;
